import Vue from 'vue'
import {
  fetchTestLinks,
  removeTestLink,
  createTestLink
} from '../../api'

const state = {
  byProject: {},
}

const getters = {}

const actions = {
  getTestLinks ({ commit }, { projectId }) {
    fetchTestLinks(projectId).then(links => {
      commit('setTestLinks', { projectId, links })
    })
  },
  addTestLink ({ commit }, { projectId, params }) {
    createTestLink(projectId, params).then(link => {
      commit('addTestLink', link)
    })
  },
  delTestLink ({ commit }, { projectId, id }) {
    removeTestLink(projectId, id).then(() => {
      commit('delTestLink', { projectId, id })
    })
  }
}

const mutations = {
  addTestLink (state, link) {
    state.byProject[link.project_id].push(link)
  },
  setTestLinks (state, { projectId, links }) {
    Vue.set(state.byProject, projectId, links || [])
  },
  delTestLink (state, { projectId, id }) {
    const index = state.byProject[projectId].map(o => o.id).indexOf(id)
    Vue.delete(state.byProject[projectId], index)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
